import {observer} from "mobx-react";
import {ShippingClientListItemDto} from "../../../api/fms";
import {useNavigate} from "react-router";
import {Linq, Pager, ScrollTable} from "../../ui";

interface FmsShippingClientListProps {
    items: ShippingClientListItemDto[]
    pages: number
}

const FmsShippingClientList = observer(function FmsShippingClientList({
                                                                          items,
                                                                          pages
                                                                      }: FmsShippingClientListProps) {
    const navigate = useNavigate()

    return <>
        <ScrollTable>
            <thead>
            <tr>
                <th>Anzeige</th>
                <th>Dienstleister</th>
                <th>Mandantennummer</th>
            </tr>
            </thead>
            <tbody>
            {items.map((val, index) => {
                const target = `/fms/shippingclient/${val.id}`

                return <tr key={index} style={{cursor: 'pointer'}} onClick={() => {
                    navigate(target)
                }}>
                    <td><Linq to={target}>{val.label}</Linq></td>
                    <td><Linq to={target}>{val.carrier}</Linq></td>
                    <td><Linq to={target}>{val.clientNumber}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={pages}/>
    </>
})

export {
    FmsShippingClientList
}
